
export enum AccessType {
    Edit="Edit", 
    View="View"
}

export enum FarmType {
    Surveyor="Surveyor", 
    Village="Village"
}
export enum WarehouseType {
    Assistants="Assistants", 
    Sources="Sources"
}
export enum LabappType {
    Assistants="Assistants", 
    Labs="Labs"
}


export enum FormStatus{
    Add="Add",
    Edit = "Edit"
}

export enum ActiveComponent{
    Admin="Admin",
    Farm="Farm",
    Warehouse="Warehouse"
}

export enum AccessType2{
    Edit="e",
    View="v"
}

export enum QualityEdit{
    QualityManager = "Quality Manager",
    VillageManager = "Village Manager",
    LocationManager = "Location Manager"
}